<template>
  <div class="vote_index" ref="vote_index">
    <div class="vote_index_top">
      <div class="vote_top">已有<span>{{this.schoolNum}}</span>所高校<span>{{this.coursesNum}}</span>部课程参赛评选，<span>{{stuNum.value}}{{stuNum.unit}}</span>名学生总计投票<span>{{voteNum.value}}{{voteNum.unit}}</span>次</div>
      <ul class="tab_box">
        <li v-for="(item,index) in this.categoryData"
          :key="index"
          :class="{act : ( isActive == item.category ? true : false ) }"
          @click="tabchange(item.category);isActive=item.category;"
          >
          {{item.value}}
          </li>
      </ul>
      <div class="vote_index_icon left_icon"></div>
      <div class="vote_index_icon right_icon"></div>
      <div class="vote_index_fg"></div>
    </div>
    <div class="vote_center">
      <div class="vote_search">
        <input 
        v-model="keyword" 
        maxlength="50"
        placeholder="按高校名称进行搜索" />
        <div class="search_btn" @click="search()">搜索</div>
      </div>
      <div class="vote_list_box" v-if="this.length>0">
        <div v-for="(item,index) in this.coursesData.courses"
          :key="index"
          class="vote_list"
        >
          <img class="vote_img" :src="item.img" @click="videoDetail(item.video_url)" />
          <p class="vote_name">{{item.name}}</p>
          <p class="vote_id">视频ID：<label>{{item.id}}</label></p>
          <p class="vote_org">{{item.org}}</p>
          <p class="vote_msg"><span class="vote_msg_l">总评分：<label>{{item.score}}</label>分</span><span class="vote_msg_r">总投票：<label>{{item.vote}}</label>人</span></p>
          <!-- <div class="vote_btn" @click="voteDetail(categoryid,item.id,item.video_url)" v-if="isEnd">我要投票</div>
          <div class="vote_btn" v-else @click="tips()">我要投票</div> -->
          <div class="vote_btn vote_over_btn">投票已结束</div>
        </div>
        
      </div>
      <div class="list_null" v-else>暂无数据！！！</div>
      <div class="page_box" v-show="this.length>0">
        <el-pagination
          background
          layout="pager"
          :page-size="12"
          @current-change="handleCurrentChange"
          :total="this.nums">   
        </el-pagination>
      </div>
    </div>
    
    
    <!---查看视频弹层--->
    <el-dialog
      title="视频预览"
      :visible.sync="videoPop"
      width="550px"
      top='200px'
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @close="closeVideoPop"
      center>
      <div class="video_box" v-if="videoUrl">
        <video id="video" width="500" height="350" controls>
          <source :src='this.videoUrl' type="video/mp4">
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </el-dialog>
     <!---投票弹层--->
    <el-dialog
      title="课程投票"
      :visible.sync="votePop"
      width="550px"
      top='200px'
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @close="closeVotePop"
      center>
      <div class="video_box" v-if="videoUrl">
        <video id="vote_video" width="500" height="350" controls>
          <source :src='this.videoUrl' type="video/mp4">
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <ul class="vote_list">
        <li>
          <span>课程内容</span>
          <div class="star_box">
            <el-rate
              v-model="a_score_val"
              :max="3"
              :disabled="isVote!=0"
              @change="changeAscore"
              >
            </el-rate>
          </div>
        </li>
        <li>
          <span>讲师表现</span>
          <div class="star_box">
            <el-rate
              v-model="b_score_val"
              :max="3"
              :disabled="isVote!=0"
              @change="changeBscore"
              >
            </el-rate>
          </div>
        </li>
        <li>
          <span>拍摄质量</span>
          <div class="star_box">
            <el-rate
              v-model="c_score_val"
              :max="3"
              :disabled="isVote!=0"
              @change="changeCscore"
              >
            </el-rate>
          </div>
        </li>
      </ul>
     
      <div class="pop_vote_btn" @click="useVote(a_score_val,b_score_val,c_score_val)" v-if="vote_state==0">投票</div>
      <div class="pop_vote_btn_over" v-else-if="vote_state==1">已投票</div>
      <div class="pop_vote_btn_over" v-else-if="vote_state==2">投票已达3000人上限</div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import API from "../api";
import axios from "axios";
import {categoryData} from "../common/js/data";
export default {
  name: "",
  components: {
  },
  data() {
    return {
      username: "",
      stuNum:{},
      voteNum:{},
      schoolNum:0,
      coursesNum:0,
      coursesData:{},
      length:0,
      category:1,
      statistics:{},
      baseUrl: '',
      isActive: 1,
      categoryData:categoryData,
      videoPop:false,
      videoUrl:'',
      keyword:'',
      page:1,
      courses:{},
      videoPop:false,
      videoUrl:'',
      nums:0,
      categoryid:0,
      coursesid:0,
      votePop:false,
      a_score_val:0,
      b_score_val:0,
      c_score_val:0,
      vote_state:0,
      isEnd:true,
      isVote:0,
      vote_msg:true,
    };
  },
  computed: {
     
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      this.baseUrl = 'http://www.yooc.test';
      this.$cookies.set('sessionid', '56da471ab99e2c19b8933d587adde65f')
    } else {
      // 测试环境
      if (process.env.type === 'test') {
        this.baseUrl = 'http://www.yooc.test';
        // 正式环境
      } else {
        this.baseUrl = 'https://www.yooc.me';
      }
    };
   this.getStatistics();
   this.getCourses(this.category,this.keyword,this.page);
  },
  
  methods: {
   
    //获取专题统计数据
    async getStatistics(){
      var URL =this.Host+'/statistics'
      await this.$axios.get(URL)
      .then((res)=>{
        var result = res.data.result
        if(!result){
          console.error(res.data.message);
          return;
        }
        this.statistics=res.data.data;
        this.stuNum=this.numberFormat(this.statistics.total_student)
        this.voteNum=this.numberFormat(this.statistics.total_vote)
        
      }).catch((error)=>{
        console.error(error);
      }) 
    },
     //获取课程列表数据
    async getCourses(category,keyword,page){
      var URL =this.Host+'/courses'
      await this.$axios.get(URL,{params:{category:category,q:keyword,page:page}})
      .then((res)=>{
        var result = res.data.result
        if(!result){
          console.error(res.data.message);
          return;
        }
        this.schoolNum=res.data.total_org;
        this.coursesNum=res.data.total;
        this.coursesData=res.data;
        this.length=this.coursesData.courses.length;
        this.nums=res.data.nums;
        this.categoryid=res.data.category;
        if(this.coursesData.end!=0){
          this.isEnd=false;
        }
        // this.isEnd=this.coursesData.end;
        // console.log(this.coursesData,this.isEnd)
      }).catch((error)=>{
        console.error(error);
      }) 
    },
    async tabchange(val){
      // console.log(val)
      this.category=val;
      // console.log(this.category)
      this.page=1;
      this.keyword='';
      this.getCourses(this.category,this.keyword,this.page);
    },
    //搜索关键词
    async search(){
      // console.log(this.keyword);
      this.page=1;
      this.getCourses(this.category,this.keyword,this.page);
    },
    //分页切换
    async handleCurrentChange(currentPage){
      this.page=currentPage;
      this.getCourses(this.category,this.keyword,this.page);
    },
    //视频预览弹窗
    async videoDetail(url){
      // console.log(url);
      this.videoUrl=url;
      this.videoPop=true;
    },
    //关闭视频预览弹窗
    closeVideoPop(){
      var video=document.getElementById("video");
      video.pause();
      this.videoUrl='';
    },
    //投票弹窗
     voteDetail(categoryid,courseId,videourl){
      this.videoUrl=videourl;
      this.categoryid=parseInt(categoryid);
      this.coursesid=courseId;
      // console.log(categoryid,courseId,videourl)
      // this.votePop=true;
      var URL =this.Host+'/user_vote'
       this.$axios.get(URL,{params:{category:categoryid,courseId:courseId}})//,test:0,voted:2 本地测试参数
      .then((res)=>{
        var result = res.data.result
        // console.log(this.vote_state,this.a_score_val,this.b_score_val,this.c_score_val)
        var error = res.data.error
        if(error==403){
          window.location.href="/login"; 
        }
        this.vote_state=res.data.data.voted
        this.isVote=res.data.data.voted
        // console.log(this.vote_state,res.data.data.voted)
        if(this.vote_stat!=0){
          this.a_score_val=res.data.data.a_score;
          this.b_score_val=res.data.data.b_score;
          this.c_score_val=res.data.data.c_score;
          // console.log(res.data.data.voted)
        }else{
          this.a_score_val=0;
          this.b_score_val=0;
          this.c_score_val=0;
        }
        this.votePop=true;
        // console.log(res.data)

      }).catch((error)=>{
        console.error(error);
      }) 
    },
    tips(){
      alert('投票评分已结束')
    },
    changeAscore(val){
      // console.log(val)
    },
    changeBscore(val){
      // console.log(val)
    },
    changeCscore(val){
      // console.log(val)
    },
    //关闭投票弹窗
    closeVotePop(){
      var video=document.getElementById("vote_video");
      video.pause();
      this.videoUrl='';
      this.a_score_val=0;
      this.b_score_val=0;
      this.c_score_val=0;
      this.votePop=false;
    },
    async useVote(a,b,c){
      // console.log(this.categoryid,this.coursesid,a,b,c)
      var URL =this.Host+'/vote';
      await this.$axios.post(URL,{category:this.categoryid,
      courseId:this.coursesid,
      a_score:a,
      b_score:b,
      c_score:c})
      .then((res)=>{
        var error = res.data.error
        if(error==403){
          window.location.href="/login"; 
        }
        this.videoUrl='';
        this.a_score_val=0;
        this.b_score_val=0;
        this.c_score_val=0;
        this.votePop=false;
        // console.log(res)
      }).catch((error)=>{
        console.error(error);
      }) 
    },
    //数字转换
    numberFormat(value){
        let param = {}
        let k = 10000
        let sizes = ['', '万', '亿', '万亿']
        let i
        if (value < k) {
            param.value = value
            param.unit = ''
        } else {
            i = Math.floor(Math.log(value) / Math.log(k));
            param.value = ((value / Math.pow(k, i))).toFixed(2);
            param.unit = sizes[i];
        }
        return param;
    }
  }
};
</script>
<style lang="scss" rel="stylesheet/stylus" type="text/stylus">
.vote_index{
  .vote_index_top{
    position: relative;
    height: 190px;
    .vote_index_icon{
      width: 13px;
      height: 67px;
      background: url('../assets/images/index_icon.png') no-repeat;
      position: absolute;
      z-index: 2;
    }
    .left_icon{
      top: 73px;
      left: 10px;
    }
    .right_icon{
      top: 73px;
      right: 15px;
    }
    .vote_index_fg{
     width: 1048px;
     height: 3px;
     background: #6990EB;
     position: absolute;
     z-index: 0;
     top: 145px;
     left: 10px;
    }
    .vote_top{
      width: 1100px;
      height: 100px;
      background: url('../assets/images/menu_top.png') no-repeat;
      text-align: center;
      font-size: 18px;
      color: #fff;
      line-height: 100px;
      span{
        font-size: 24px;
        color: #FFF176;
        font-weight: bold;
        margin: 0 3px;
      }
    }
    .tab_box{
      margin-top: 20px;
      height: 55px;
      display: flex;
      justify-content:space-between;
      width: 1100px;
      position: absolute;
      z-index: 1;
      li{
        width: 200px;
        line-height: 55px;
        color: #fff;
        cursor: pointer;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        background: url('../assets/images/menu.png') no-repeat;
      }
      li:hover{
        color: #fff;
        background: url('../assets/images/menu_hover.png') no-repeat;
      }
      .act{
        color: #fff;
        background: url('../assets/images/menu_hover.png') no-repeat;
      }
    }
  }
  .vote_center{
    width: 1105px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px 0;
    overflow: hidden;
    margin-top: 15px;
  }
  .vote_search{
    width: 593px;
    height: 45px;
    border-radius: 8px;
    margin: 20px 0 0 258px;
    overflow: hidden;
    background: url('../assets/images/search_icon.png') #F1F1F1 11px 13px no-repeat;
    input{
      float: left;
      height: 44px;
      margin-left: 40px;
      width: 440px;
      padding-right: 20px;
      background: #F1F1F1;
    }
    .search_btn{
      cursor: pointer;
      border-radius: 8px;
      background: #6990EB;
      height: 44px;
      width: 90px;
      float: right;
      color: #fff;
      font-size: 16px;
      line-height: 44px;
      text-align: center;
    }
  }
  .vote_list_box{
    overflow: hidden;
    margin-left: 30px;
    .vote_list{
      width: 270px;
      height: 400px;
      float: left;
      margin:30px 38px 0 38px;
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid #F1F1F1;
      .vote_img{
        width: 270px;
        height: 201px;
        border-radius: 4px;
        cursor: pointer;
      }
      .vote_name{
        padding:0 10px;
        height: 42px;
        line-height: 21px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin-top: 5px;
        font-weight: bold;
        font-size: 14px;
      }
      .vote_id{
        padding:0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 10px;
        font-weight: bold;
        label{
          color: #ff9c0b;
          font-weight: bold;
        }
      }
      .vote_org{
        padding:0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 5px;
        font-weight: bold;
      }
      .vote_msg{
        color: #999999;
        padding:0 10px;
        margin-top: 5px;
        overflow: hidden;
        .vote_msg_l{
          float: left;
           label{
            color: #ff9c0b;
            font-weight: bold;
          }
        }
        .vote_msg_r{
          float: right;
           label{
            color: #ff9c0b;
            font-weight: bold;
          }
        }
      }
      .vote_btn{
        width: 252px;
        height: 40px;
        background: url('../assets/images/vote_btn.png');
        margin: 20px 0 0 10px;
        cursor: pointer;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        line-height: 40px;
      }
      .vote_over_btn{
        width: 252px;
        height: 40px;
        background: url('../assets/images/vote_btn_over.png');
        margin: 20px 0 0 10px;
        text-align: center;
        cursor: default;
        font-weight: bold;
        font-size: 14px;
        line-height: 40px;
      }
    }
  }
  .list_null{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin: 15px 0;
  }
  .page_box{
    text-align: center;
    margin: 20px 0 0 0 ;
  }
  .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color:transparent!important;
    background: #FF9B57!important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #FF9B57!important;
  }
  .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
    color:#fff!important;
  }
  .el-rate__icon{
    font-size: 22px;
    // color: #fe8333!important;
  }
  .vote_list{
    width: 100%;
    overflow: hidden;
    margin-top: 20px;
    li{
      display: flex;
      justify-content:space-between;
      margin: 0 0 15px 0;
      span{
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .video_box{
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pop_vote_btn{
    width: 500px;
    height: 44px;
    background: url('../assets/images/pop_vote_btn.png');
    margin: 10px 0;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 44px;
    color: #000;
  }
  .pop_vote_btn_over{
    width: 500px;
    height: 44px;
    background: url('../assets/images/pop_vote_btn_hover.png');
    margin: 10px 0;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 44px;
    color: #aaa;
  }
}
  
</style>


// WEBPACK FOOTER //
// vote.vue?bd4d2a6a